<template>
	<!--框选和显示密度层-->
	<canvas ref="selectCanvas" v-bind:width="width" v-bind:height="height" />
</template>

<script>
	import { store } from './store'
	export default {
		data() {
			return {
				selectCanvas: null,
				selectedCoord: [],
				origin: [],
			}
		},
		props: {
			/**
			 * 宽。
			 */
			width: {
				type: Number,
			},
			/**
			 * 高
			 */
			height: {
				type: Number,
			},
			/**
			 * x，y，w，h
			 */
			imageLocation: {
				type: Object,
				default: () => {
					return {
						x: 0,
						y: 0,
						w: 0,
						h: 0,
					}
				},
			},
			/**
			 *
			 */
			scale: {
				type: Number,
				default: 1,
			},
		},
		computed: {
			/**
			 * 密度点圆的半径。
			 */
			pointRadius() {
				return store.state.pointRadius
			},
			/**
			 * 是否显示密度点。
			 */
			showPoints() {
				return store.state.defectPointVisible
			},
			/**
			 * 缺陷点记录。
			 */
			pointsData() {
				var defects = store.state.filteredDefects

				var data = defects.map(p => {
					return {
						id: p._id.$oid,
						x: p.pos_x + p.size_cx / 2,
						y: p.pos_y + p.size_cy / 2,
					}
				})

				return data
			},
		},
		watch: {
			showPoints(val) {
				if (val) {
				}
			},
		},
		methods: {
			/**
			 * 判断鼠标是否点击该圆形区域。
			 */
			isHover(x, y, x2, y2) {
				// 勾股定理
				return Math.pow(x - x2, 2) + Math.pow(y - y2, 2) <= Math.pow(this.pointRadius, 2)
			},
			/**
			 * X点坐标转换，将鼠标坐标转换成图片实际位置的X点坐标。
			 */
			parseImageOriginX(value) {
				return parseFloat(((value - this.imageLocation.x) / this.scale).toFixed(2))
			},
			/**
			 * Y点坐标转换，将鼠标坐标转换成图片实际位置的Y点坐标。
			 */
			parseImageOriginY(value) {
				return parseFloat(((value - this.imageLocation.y) / this.scale).toFixed(2))
			},
			/**
			 * 准备进行框选
			 */
			mousedownHandler(e) {
				this.origin = [e.offsetX, e.offsetY]
				var ctx = this.selectCanvas.getContext('2d')
				//清空上次绘制记录。
				ctx.clearRect(0, 0, this.width, this.height)

				//监听鼠标移动事件。
				this.selectCanvas.addEventListener('mousemove', this.mousemoveHandler)

				//点击点。
				if (this.showPoints) {
					var selectedPoints = null
					for (var i = 0; i < this.pointsData.length; i++) {
						var coord = this.pointsData[i]
						var x1 = this.imageLocation.x + coord.x * this.scale
						var y1 = this.imageLocation.y + coord.y * this.scale

						//console.log(x1, y1)

						if (this.isHover(e.offsetX, e.offsetY, x1, y1)) {
							if (selectedPoints == null) {
								selectedPoints = {
									id: coord.id,
									x: coord.x,
									y: coord.y,
								}

								break
							}
						}
					}

					this.$emit('selectedPoints', selectedPoints)
				}

				//设置选中区域片中的x1，y1
				this.selectedCoord.x1 = this.parseImageOriginX(e.offsetX)
				this.selectedCoord.y1 = this.parseImageOriginY(e.offsetY)
			},
			/**
			 * 进行框选。
			 */
			mousemoveHandler(e) {
				if (this.origin[0] === 0 || this.origin[1] === 0) {
					return
				}

				//确保按下才发生
				this.width2height = [e.offsetX - this.origin[0], e.offsetY - this.origin[1]]

				//矩形框太小，返回
				if (Math.abs(this.width2height[0]) < 10 && Math.abs(this.width2height[1]) < 10) {
					return
				}

				var ctx = this.selectCanvas.getContext('2d')
				//清空上次绘制记录。
				ctx.clearRect(0, 0, this.width, this.height)
				ctx.fillStyle = '#fff0'

				ctx.fillRect(this.origin[0] + 0.5, this.origin[1] + 0.5, this.width2height[0], this.width2height[1])

				ctx.strokeStyle = '#a9ff37'
				ctx.strokeRect(this.origin[0] + 0.5, this.origin[1] + 0.5, this.width2height[0], this.width2height[1])
			},
			/**
			 * 释放框选的事件。
			 */
			mouseupHandler(e) {
				this.selectedCoord.x2 = this.parseImageOriginX(e.offsetX)
				this.selectedCoord.y2 = this.parseImageOriginY(e.offsetY)

				//移除移动事件监听，相当于框选完成。
				this.selectCanvas.removeEventListener('mousemove', this.mousemoveHandler)

				var coordinate = this.getSelectCoordinate(this.selectedCoord)

				//设置查询条件；选中区域。
				store.setFilter({
					selectionArea: coordinate,
				})
			},
			/**
			 * 获取框选坐标。
			 */
			getSelectCoordinate(rect) {
				console.log('选择结束：', rect)
				var x1,
					y1,
					x2,
					y2 = ''

				x1 = String(rect.x1.toFixed(0))
				x2 = String(rect.x2.toFixed(0))
				y1 = String(rect.y1.toFixed(0))
				y2 = String(rect.y2.toFixed(0))

				if (rect.x1 == rect.x2) {
					x1 = x2 = ''
				}

				if (rect.y1 == rect.y2) {
					y1 = y2 = ''
				}

				return [x1, y1, x2, y2]
			},
		},
		mounted() {
			//注册事件。
			this.selectCanvas = this.$refs.selectCanvas
			this.selectCanvas.addEventListener('mousedown', this.mousedownHandler)
			this.selectCanvas.addEventListener('mousemove', this.mousemoveHandler)
			this.selectCanvas.addEventListener('mouseup', this.mouseupHandler)
		},
		created() {},
	}
</script>

<style></style>
